import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import ToggleSwitch from "./ToggleSwitch/ToggleSwitch";

const Navbar: React.FC = () => {
  return (
    <AppBar position="static" sx={{ bgcolor: 'main' }}>
      <Toolbar>
        <Typography
          variant="h6"
          component="div"
          sx={{
            textDecoration: "none",
            color: "inherit",
          }}
        >
          <RouterLink
            to="/"
            style={{
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <Typography
              sx={{
                display: "inline-block",
              }}
            >
              Tomte Investments
            </Typography>
          </RouterLink>
        </Typography>
        <Box sx={{ marginLeft: "auto" }}>
          <Button color="inherit" component={RouterLink} to="/">
            Home
          </Button>
          <Button color="inherit" component={RouterLink} to="/about">
            About
          </Button>
          <Button color="inherit" component={RouterLink} to="/more">
            More
          </Button>
          <ToggleSwitch />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;